import axios from "axios";

import { headers, host } from "./shared";
import type { UserJob } from "../../types/userJob";

export const getUserJobs = async (
  accessToken?: string | null,
): Promise<{ jobs: UserJob[] }> => {
  const response = await axios.get(
    `${host}/api/user_jobs`,
    headers(accessToken),
  );
  return response?.data;
};

export const getUserJob = async (
  accessToken: string | null | undefined,
  jobId: string,
): Promise<{ job: UserJob }> => {
  const response = await axios.get(
    `${host}/api/user_jobs/${jobId}`,
    headers(accessToken),
  );
  return response?.data;
};
